<template>
    <div>
        <el-container style="height: 100vh">
            <el-aside width="auto">
                <common-aside/>
            </el-aside>
            <el-container>
                <el-header>
                    <common-header/>
                </el-header>
                <el-main id="el-main">
                    <!-- 子路由的出口 -->
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import CommonAside from '../components/CommonAside.vue'
import CommonHeader from '../components/CommonHeader.vue'

export default {
    data() {
        return {};
    },
    components: {
        CommonAside,
        CommonHeader
    }
}
</script>

<stype lang="less" scoped>
    .el-header {
        padding: 0
    }
</stype>